import { DealerManagementService } from '../../../../services/dealer-management.service';
import { forgotPasswordValidations } from './validations';
import Input from '../../../../components/forms/input';
import ReCAPTCHA from 'react-google-recaptcha';
import { RECAPTCHA_SITE_KEY } from 'src/config';
import Spinner from '../../../../components/ui/spinner';
import { useFormik } from 'formik';
import { useLocalization } from '../../../../utils/useLocalization';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import React, { Dispatch, SetStateAction, useEffect, useState } from 'react';
import './styles.scss';

export interface IProps {
    setShowSuccess: Dispatch<SetStateAction<boolean>>;
    setEmail: Dispatch<SetStateAction<string>>;
}

const InfoInput: React.FC<IProps> = ({ setShowSuccess, setEmail }) => {
    const { accountRegistration, addNewUser, forgotPassword } =
        useLocalization();
    const { i18n } = useTranslation();
    useEffect(() => {
        setLanguage(selectLanguageStr());
    }, [i18n.language]);
    const navigation = useNavigate();
    const [loading, setLoading] = useState<boolean>(false);
    const [language, setLanguage] = useState<string>(selectLanguageStr());
    const [networkError, setNetworkError] = useState<boolean>(false);
    const reRef = React.createRef<ReCAPTCHA>();
    const [reToken, setReToken] = useState<string | null>('');
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [submitErrors, setSubmitErrors] = useState({
        email: '',
    });
    const {
        values,
        errors,
        touched,
        handleChange,
        handleSubmit,
        handleBlur,
        setFieldTouched,
    } = useFormik({
        initialValues: {
            email: '',
        },
        validationSchema: forgotPasswordValidations,
        onSubmit: handlerSubmit,
    });

    function onCancelHandler() {
        navigation('/login');
    }

    function showNotification() {
        setNetworkError(true);
    }

    function onChange(value: any) {
        setReToken(value);
    }

    function selectLanguageStr() {
        return i18n.language.includes('en-') ? 'en' : 'fr';
    }

    async function handlerSubmit() {
        setNetworkError(false);
        setLoading(true);
        try {
            const { email } = values;
            if (reToken !== null) {
                const service = new DealerManagementService();
                const res = await service.sendForgotPasswordRequest({
                    username: email,
                    reToken: reToken,
                });
                if (res && res.data) {
                    setShowSuccess(true);
                    setEmail(email);
                } else {
                    setEmail('');
                    setReToken('');
                }
            } else {
                throw new Error('Token Error');
            }
        } catch (e) {
            showNotification();
        } finally {
            setLoading(false);
        }
    }
    useEffect(() => {
        const handleLanguageChange = () => {
            Object.keys(touched).forEach((field) => {
                setFieldTouched(field, true, true);
            });
        };

        i18n.on('languageChanged', handleLanguageChange);
        return () => {
            i18n.off('languageChanged', handleLanguageChange);
        };
    }, [i18n, touched, errors, setFieldTouched]);

    return (
        <div className={'forgot_password_container'}>
            <div className={''}>
                {networkError && (
                    <section
                        id='js-notifications-group'
                        className='c-notifications-group  js-panelgroup js-panelgroup js-is-fx is-stacked js-is-ready u-mb-small u-mt-xsmall'
                    >
                        <div
                            className={
                                'c-notification__container  js-notification-container'
                            }
                        >
                            <div className='c-notification  c-notification--error'>
                                <div className='c-notification__outer-wrap'>
                                    <div className='c-notification__inner-wrap'>
                                        <div className='c-notification__content'>
                                            <p className='c-notification__text'>
                                                {
                                                    accountRegistration.ACC_REG_LABEL_NOTIFICATION_ERROR
                                                }
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                )}
                <h4>{forgotPassword.TITLE}</h4>
                <p className={'description u-mt'}>
                    {forgotPassword.DESCRIPTION}
                </p>
            </div>
            <form
                onSubmit={handleSubmit}
                autoComplete={'off'}
                className={'u-mt-xlarge'}
            >
                <Input
                    labelName={forgotPassword.LABEL_EMAIL}
                    type={'text'}
                    name={'email'}
                    maxlength={50}
                    handlerChange={handleChange}
                    handlerBlur={handleBlur}
                    value={values.email}
                    asErrors={errors.email}
                    asTouched={touched.email}
                    asSubmitError={submitErrors.email}
                />
                <div className='recaptcha_container u-mt-xlarge u-mb-xlarge'>
                    <ReCAPTCHA
                        sitekey={RECAPTCHA_SITE_KEY}
                        ref={reRef as React.RefObject<ReCAPTCHA>}
                        onChange={onChange}
                        hl={language}
                        key={language}
                    />
                </div>
                <div className='o-button-container'>
                    <button
                        className={
                            'c-btn c-btn--secondary o-button-container__button'
                        }
                        type={'button'}
                        onClick={onCancelHandler}
                    >
                        <span className='c-btn__text'>
                            {addNewUser.MODAL_LABEL_BUTTON_CANCEL}
                        </span>
                    </button>
                    <button
                        className='c-btn o-button-container__button'
                        disabled={
                            values.email === '' ||
                            !!Object.keys(errors).length ||
                            reToken === '' ||
                            reToken === null ||
                            loading
                        }
                        type={'submit'}
                    >
                        <span className='c-btn__text'>
                            {loading ? (
                                <Spinner />
                            ) : (
                                accountRegistration.ACC_REG_LABEL_CONTINUE
                            )}
                        </span>
                    </button>
                </div>
            </form>
        </div>
    );
};

export default InfoInput;
